var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.value)?_c('BaseEmpty',{attrs:{"message":"未选择任何工作任务"}}):(_vm.items.length == 0)?_c('BaseEmpty',{attrs:{"message":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }